module.exports = __webpack_public_path__ + "static/media/banktransfer.5f6714c5.png";